<template>
  <div class="page-container mt-4">
    <section>
      <withdrawal-account v-if="me" :me="me"></withdrawal-account>
    </section>
  </div>
</template>

<script>
import WithdrawalAccount from '@/components/bank/WithdrawalInfo.vue'
import { mapState } from 'vuex'

export default {
  components: { WithdrawalAccount },
  computed: {
    ...mapState('auth', ['me', 'meRefreshKey']),
  },
  created() {
    _meta({
      titles: ['입금용주계좌 정보'],
    })
  },
}
</script>
